<div class="row mh-100">
    <div class="col-md-5 mx-auto p-2 p-md-5">
        <div class="card bg-light border-0 rounded-3">
            <div class="card-body">
                <div class="text-center">
                    <img class="mb-3" src="/assets/logo.png"><br>
                    <div *ngIf="!success" class="fw-bold">
                        Forgot Password
                    </div>
                    <div *ngIf="!success">Please type your email</div>
                </div>
                <div class="row" *ngIf="success">
                    <div class="col-12 p-3">
                        <div class="alert alert-success">
                            We have sent you a link, please check your inbox or spam box on your email.
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <a href="/login" [attr.disabled]="loading.status?'disabled':null" class="btn-link btn-primary py-2 px-4 w-100">
                            Back to Login page
                        </a>
                    </div>
                </div>
                <div class="row" *ngIf="!success">
                    <form class="p-3 col-12" [formGroup]="loginForm" #thisForm="ngForm" (ngSubmit)="submitForm(loginForm)" novalidate>
                        <div class="form-floating mb-4">
                            <input type="email" formControlName="email" [class.is-invalid]="loginForm.get('email')?.invalid && (thisForm.submitted || loginForm.get('email')?.touched)" placeholder="name@example.com" class="form-control" required>
                            <label>Email</label>
                            <div class="text-danger position-absolute w-100" *ngIf="loginForm.get('email')?.invalid && (thisForm.submitted || loginForm.get('email')?.touched)">
                                <small class="small" *ngIf="loginForm.get('email')?.errors?.required">Type your email</small>
                                <small *ngIf="loginForm.get('email')?.errors?.email">Email is not valid</small>
                                <small *ngIf="loginForm.get('email')?.errors?.serverError">{{loginForm.get('email')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between mb-4">
                            <div class="col-12">
                                <button type="submit" [attr.disabled]="loading.status?'disabled':null" class="btn btn-primary py-2 px-4 w-100">
                                    Reset Password
                                </button>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <a [class.disabled]="loading.status" class="btn-link text-nowrap text-seoncdary" routerLink="/login">
                                    Back to login page
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showNotification" class="success d-flex justify-content-center align-items-center position-fixed w-100 h-100">
    <div class="card bg-light text-dark fw-bold">
        <div class="card-body">
            <div class="text-center p-3">
                <div class="alert alert-success">
                    Congratulations your password successfully reseted, please login to continue.
                </div>
                <p>
                    <button (click)="closeNotification()" class="btn btn-primary w-100 text-white">
                        Login
                    </button>
                </p>
            </div>
        </div>
    </div>
</div>
